
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/waiver",
      function () {
        return require("private-next-pages/waiver.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/waiver"])
      });
    }
  